import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Popover, { PopoverProps } from "@mui/material/Popover";
import { useTheme } from "@mui/material/styles";
import Aspera from "csi/comm/Aspera";
import { IFileData } from "csi/typings";
import React, { FunctionComponent } from "react";
import { POPOVER_TOP_END } from "designSystem/styles/popover-positions";
import { propsWithSx } from "designSystem/styles/style-functions";
import { popperPaperStyle } from "designSystem/styles/style-functions";
import File from "./File";

interface FilesPopoverProps extends PopoverProps {
	/** list of files to show in popover */
	files: IFileData[];

	/** event handler for delete action, if available */
	onDelete?: (fileData: IFileData) => void;

	/** event handler for image link, if available */
	onImage?: (fileData: IFileData) => void;
}

const paperStyles = (theme) => ({
	...popperPaperStyle(theme),
	maxHeight: 250,
	maxWidth: 300,
});

const FilesPopover: FunctionComponent<FilesPopoverProps> = (props) => {
	const { files, onDelete, onImage, PaperProps, ...otherProps } = props;
	const theme = useTheme();

	const onDownload = (fileData: IFileData): void => {
		Aspera.downloadFile(fileData.id);
	};

	return (
		<Popover
			PaperProps={propsWithSx(PaperProps, paperStyles(theme))}
			{...POPOVER_TOP_END}
			{...otherProps}
		>
			<Box my={1}>
				<Grid
					container
					direction="column"
					spacing={1}
					wrap="nowrap"
				>
					{files.map((fileData, i) => {
						const { file, id } = fileData;
						const inProgress = !!file;

						return (
							<Grid
								item
								key={id}
							>
								<Box mx={3}>
									<File
										download={!inProgress}
										fileData={fileData}
										hoverStyling
										onDelete={onDelete ? () => onDelete(fileData) : null}
										onDownload={Aspera.isEnabled() ? () => onDownload(fileData) : null}
										onImage={onImage ? () => onImage(fileData) : null}
										uploading={inProgress}
									/>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Box>
		</Popover>
	);
};

export default FilesPopover;
